import {flexRender, HeaderGroup} from '@tanstack/react-table';
import React from 'react';

import {ChevronSmallDown, ChevronSmallUp} from '@ELib/assets/images';
import {classy, classyArray} from '@ELib/utilities/HelperFunctions';

import {ETableRow} from './types';

export function THead({
  headerGroups,
  hidden,
  showColumnConfigDialog,
}: {
  headerGroups: HeaderGroup<ETableRow>[];
  hidden?: boolean;
  showColumnConfigDialog?: () => void;
}): React.ReactElement {
  const handleRightClick = (event: React.MouseEvent) => {
    event.preventDefault();
    showColumnConfigDialog?.();
  };
  return (
    <thead style={{height: hidden ? 0 : undefined}}>
      {headerGroups.map((headerGroup) => (
        <tr
          key={headerGroup.id}
          data-testid='ETable-THead-row'
          role='row'
          style={{height: hidden ? 0 : undefined}}
          onContextMenu={handleRightClick}
        >
          {headerGroup.headers.map((header) => {
            const {column} = header;
            const canSort = column.getCanSort();
            const {meta} = column.columnDef;
            return (
              <th
                key={header.id}
                className={classyArray([
                  // styling that is defined by the user
                  meta?.className,
                  // styling that relies on the column type and state
                  classy({
                    canSort,
                    isSorted: column.getIsSorted() !== false,
                    header: column.id !== '_selection',
                    selection: column.id === '_selection',
                  }),
                ])}
                colSpan={header.colSpan}
                data-testid={`ETable-header-${column.id}`}
                role='columnheader'
                style={{
                  ...meta?.style,
                  height: hidden ? 0 : undefined,
                }}
                // reset the title which was added by default in react-table v7
                title={canSort ? '' : undefined}
                onClick={canSort ? column.getToggleSortingHandler() : undefined}
              >
                <RenderIfVisible hidden={hidden}>
                  {column.id === '_selection' ? (
                    flexRender(column.columnDef.header, header.getContext())
                  ) : (
                    <div>
                      <span>
                        {flexRender(
                          column.columnDef.header,
                          header.getContext()
                        )}
                      </span>
                      {canSort ? (
                        column.getIsSorted() === 'desc' ? (
                          <ChevronSmallDown />
                        ) : (
                          <ChevronSmallUp />
                        )
                      ) : null}
                    </div>
                  )}
                </RenderIfVisible>
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
}

function RenderIfVisible({
  hidden = false,
  children,
}: {
  hidden?: boolean;
  children: React.ReactNode;
}): React.ReactNode {
  return hidden ? null : children;
}
